(function () {
  const desktopQuery = window.matchMedia('(min-width: 1024px)');

  function initBannannaHeaderSystem(system) {
    if (!system || system.dataset.bnnHeaderSystemReady === 'true') return;

    const nav = system.querySelector('[data-bnn-header-nav]');
    const panelRoot = system.querySelector('[data-bnn-nav-panel-root]');
    const triggers = Array.from(system.querySelectorAll('[data-bnn-nav-trigger]'));
    const panels = Array.from(system.querySelectorAll('[data-bnn-nav-panel]'));
    const firstHomepageAct = document.querySelector('[data-bnn-first-act]');
    let closeTimer = null;

    if (!nav || !panelRoot || !triggers.length || !panels.length) return;

    function syncPanelHeight() {
      if (!firstHomepageAct) {
        system.style.removeProperty('--bnn-header-panel-height');
        return;
      }

      const firstActHeight = Math.ceil(firstHomepageAct.getBoundingClientRect().height);
      if (firstActHeight > 0) {
        system.style.setProperty('--bnn-header-panel-height', `${firstActHeight}px`);
      }
    }

    function setActivePanel(panelName, openPanel) {
      triggers.forEach((trigger) => {
        const isActive = trigger.dataset.bnnNavTrigger === panelName;
        trigger.classList.toggle('is-active', openPanel && isActive);
        trigger.setAttribute('aria-selected', openPanel && isActive ? 'true' : 'false');
        trigger.setAttribute('aria-expanded', openPanel && isActive ? 'true' : 'false');
        trigger.tabIndex = openPanel && !isActive ? -1 : 0;
      });

      panels.forEach((panel) => {
        const isActive = panel.dataset.bnnNavPanel === panelName;
        panel.hidden = !isActive;
        panel.setAttribute('aria-hidden', openPanel && isActive ? 'false' : 'true');
      });
    }

    function openPanel(panelName) {
      clearTimeout(closeTimer);
      syncPanelHeight();
      panelRoot.hidden = false;
      nav.classList.add('is-panel-open');
      system.classList.add('is-panel-open');
      setActivePanel(panelName, true);
    }

    function closePanel() {
      clearTimeout(closeTimer);
      nav.classList.remove('is-panel-open');
      system.classList.remove('is-panel-open');
      panelRoot.hidden = true;
      triggers.forEach((trigger) => {
        trigger.classList.remove('is-active');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.setAttribute('aria-selected', 'false');
        trigger.tabIndex = 0;
      });
    }

    function queueClosePanel() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(closePanel, 140);
    }

    function getTriggerIndex(trigger) {
      return triggers.indexOf(trigger);
    }

    function focusTriggerByOffset(trigger, offset) {
      const currentIndex = getTriggerIndex(trigger);
      if (currentIndex < 0) return;

      const nextIndex = (currentIndex + offset + triggers.length) % triggers.length;
      const nextTrigger = triggers[nextIndex];
      nextTrigger.focus();
      openPanel(nextTrigger.dataset.bnnNavTrigger);
    }

    triggers.forEach((trigger) => {
      trigger.addEventListener('mouseenter', () => {
        if (desktopQuery.matches) openPanel(trigger.dataset.bnnNavTrigger);
      });

      trigger.addEventListener('focus', () => {
        openPanel(trigger.dataset.bnnNavTrigger);
      });

      trigger.addEventListener('click', () => {
        const panelName = trigger.dataset.bnnNavTrigger;
        const isOpen = !panelRoot.hidden && trigger.getAttribute('aria-expanded') === 'true';

        if (isOpen) {
          closePanel();
        } else {
          openPanel(panelName);
        }
      });

      trigger.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          focusTriggerByOffset(trigger, 1);
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          focusTriggerByOffset(trigger, -1);
        } else if (event.key === 'Home') {
          event.preventDefault();
          triggers[0].focus();
          openPanel(triggers[0].dataset.bnnNavTrigger);
        } else if (event.key === 'End') {
          event.preventDefault();
          const lastTrigger = triggers[triggers.length - 1];
          lastTrigger.focus();
          openPanel(lastTrigger.dataset.bnnNavTrigger);
        }
      });
    });

    system.addEventListener('mouseenter', () => clearTimeout(closeTimer));
    system.addEventListener('mouseleave', () => {
      if (desktopQuery.matches) queueClosePanel();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closePanel();
    });

    document.addEventListener('click', (event) => {
      if (!system.contains(event.target)) closePanel();
    });

    window.addEventListener('resize', syncPanelHeight);
    window.addEventListener('load', syncPanelHeight);

    if (firstHomepageAct && 'ResizeObserver' in window) {
      system.bnnFirstActObserver = new ResizeObserver(syncPanelHeight);
      system.bnnFirstActObserver.observe(firstHomepageAct);
    }

    setActivePanel('shop', false);
    syncPanelHeight();
    system.dataset.bnnHeaderSystemReady = 'true';
  }

  function initAll() {
    document.querySelectorAll('[data-bnn-header-system]').forEach(initBannannaHeaderSystem);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
